// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  setPersistence, 
  browserLocalPersistence,
  GoogleAuthProvider,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAZsp8_JVhUM6k1_qxmqo12_TV5bQ_M744",
  authDomain: "rizzologygpt.firebaseapp.com",
  projectId: "rizzologygpt",
  storageBucket: "rizzologygpt.firebasestorage.app",
  messagingSenderId: "531257060435",
  appId: "1:531257060435:web:ec189da9012132099deaa6",
  measurementId: "G-CN0GJ70G2X"
};

// Log the config for debugging
console.log('Firebase Config:', {
  apiKey: firebaseConfig.apiKey,
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const firestore = getFirestore(app);

// Initialize providers with additional settings
const providers = {
  google: new GoogleAuthProvider()
};

// Configure Google provider
providers.google.setCustomParameters({
  prompt: 'select_account'
});

// Enable persistence with local persistence for better cross-origin handling
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase persistence enabled');
  })
  .catch((error) => {
    console.error('Firebase persistence error:', error);
    // Fallback to indexedDB if browserLocalPersistence fails
    setPersistence(auth, indexedDBLocalPersistence)
      .then(() => {
        console.log('Firebase persistence enabled with indexedDB');
      })
      .catch((error) => {
        console.error('Firebase indexedDB persistence error:', error);
      });
  });

// Export everything as a single object
const firebase = {
  app,
  auth,
  firestore,
  providers,
  browserPopupRedirectResolver
};

export default firebase; 